import { Label } from '@/components/ui/label';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useTranslation } from '@/hooks/useTranslation';

interface RequiredLabelProps {
  /** `id` of the input the label belongs to. */
  htmlFor: string;
  label?: string;
  /** Red asterisk: the field must be filled. */
  required?: boolean;
  /** Amber asterisk: at least one field of its group must be filled. */
  requiredMulti?: boolean;
}

/** Field label with the asterisk(s) explaining, on hover, why the field is required. */
export function RequiredLabel({ htmlFor, label, required, requiredMulti }: RequiredLabelProps) {
  const { t } = useTranslation();

  return (
    <Label htmlFor={htmlFor} className="flex items-center space-x-1">
      <span>{label}</span>
      {required && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="cursor-help text-destructive">
              *<span className="sr-only"> ({t('common.required')})</span>
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p>{t('form.validation.requiredTooltip')}</p>
          </TooltipContent>
        </Tooltip>
      )}
      {requiredMulti && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="cursor-help text-warning">*</span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p>{t('form.validation.requiredMultiTooltip')}</p>
          </TooltipContent>
        </Tooltip>
      )}
    </Label>
  );
}
